export const PgViewConfig = Symbol.for('drizzle:PgViewConfig');
